import { gql } from '@apollo/client';

export const SEND_QUERY_REQUEST = gql`
  mutation sendQueryRequest($input: SendQueryRequestInput!) {
    sendQueryRequest(input: $input) {
      errors
      message
    }
  }
`


// {
//   "input":{
//     "originatorId": 21,
// 		"incidentId": null,
// 		"queryKey": "SVQ",
// 		"ORI": "SP",
// 		"DAC": "dac",
// 		"USR": "rraabe",
// 		"PWD": "test",
// 		"DST": "VT",

// 		"NAM": null,
// 		"DOB": null,
// 		"SEX": null,
// 		"PID": null,
// 		"OCF": null,
// 		"OLN": null,
// 		"RSN": null,
// 		"PPS": null,
// 		"LIC": null,
// 		"LIY": null,
// 		"LIT": null,
// 		"VIN": null,
// 		"VMA": null,
// 		"VYR": null,
// 		"SNM": null,
// 		"SDX": null
//   }
// }